import {
  Box,
  Card,
  CardContent,
  CardMedia,
  Stack,
  Typography,
} from '@mui/material';
import React, { useState } from 'react';
import { useMount } from 'react-use';
import { verifyingEmailAPI } from '../api/auth';

const VerificationPage = (props) => {
  const {
    match: { params },
  } = props;

  const [loading, setLoading] = useState(true);
  const [content, setContent] = useState({
    title: '',
    header: '',
    message: '',
    message2: '',
  });
  const failed = {
    title: '서큘러스 회원가입 이메일 인증 실패',
    header: '이메일 주소 인증에 실패하였습니다.',
    message:
      '해당 메일의 인증 시간이 만료되었거나 인증 과정 중 오류로 인해 인증에 실패하였습니다.',
    message2: '인증 메일 다시 보내기를 통해서 인증을 다시 한 번 시도해 주세요.',
  };

  // eslint-disable-next-line consistent-return
  useMount(() => {
    const { type, serial } = params;
    if (!type || !serial) {
      setLoading(false);
      return setContent({
        ...failed,
        title: '서큘러스 이메일 인증 오류',
        message: '메일 인증에 필요한 정보를 확인할 수 없습니다.',
      });
    }
    verifyingEmailAPI({ type, serial })
      .then((verifyResult) => {
        setLoading(false);
        const { result, userResult } = verifyResult;
        if (result) {
          return setContent({
            title: '서큘러스 회원가입 이메일 인증 완료',
            header: '이메일 주소 인증이 완료되었습니다.',
            message: `${userResult.user.email} 이메일 계정에 대한 인증이 완료되었습니다.`,
            message2:
              '파이보 모바일 페이지로 돌아가서 회원가입을 완료하시기 바랍니다.',
          });
        }
        return setContent(failed);
      })
      .catch(() => {
        setLoading(false);
        return setContent(failed);
      });
  });

  return (
    <Card sx={{ my: 4, mx: 'auto', px: 4, py: 8, maxWidth: '720px' }}>
      <CardMedia
        component="img"
        image="/image/logo_circulus.png"
        alt="Circulus Logo"
        sx={{ width: '30%' }}
      />
      {!loading && (
        <CardContent sx={{ px: 0, py: 4 }}>
          {/* <Typography variant="h3">{content.title}</Typography> */}
          <Typography variant="h4" sx={{ my: 2 }}>
            {content.header}
          </Typography>
          <Typography variant="body1">{content.message}</Typography>
          <Typography variant="body1">{content.message2}</Typography>
        </CardContent>
      )}
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'row',
          justifyContent: 'center',
          gap: 3,
          mt: 4,
        }}
      >
        <a
          href="https://circul.us/"
          style={{ display: 'flex', alignItems: 'center' }}
        >
          <img alt="AIways with you" src="/image/aiwayswithyou.png" />
        </a>
        <Stack>
          <Typography variant="body2" component="address">
            (08504) 서울특별시 금천구 서부샛길 648 대륭테크노타운6차 609호
          </Typography>
          <Typography variant="body2">
            Trademark and Copyright 2018 pibo from Circulus Inc. All rights
            reserved.
          </Typography>
        </Stack>
      </Box>
    </Card>
  );
};

export default VerificationPage;
